import { render, staticRenderFns } from "./EmailTemplatesCustomerPortalTabComponent.vue?vue&type=template&id=0cfbaa98&scoped=true&lang=pug"
import script from "./EmailTemplatesCustomerPortalTabComponent.vue?vue&type=script&lang=ts"
export * from "./EmailTemplatesCustomerPortalTabComponent.vue?vue&type=script&lang=ts"
import style0 from "./EmailTemplatesCustomerPortalTabComponent.vue?vue&type=style&index=0&id=0cfbaa98&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cfbaa98",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0cfbaa98')) {
      api.createRecord('0cfbaa98', component.options)
    } else {
      api.reload('0cfbaa98', component.options)
    }
    module.hot.accept("./EmailTemplatesCustomerPortalTabComponent.vue?vue&type=template&id=0cfbaa98&scoped=true&lang=pug", function () {
      api.rerender('0cfbaa98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/maintenance/customerPortal/EmailTemplatesCustomerPortalTabComponent.vue"
export default component.exports